import Axios from "axios"
import { ApiResponse, handleApiErrors } from ".."
import * as Models from "./models"
import * as ShortModels from "../short/models"
import * as UserModels from "../usermanagement/models"

const baseUrl = () => {
    return `${process.env.REACT_APP_MOBILBASE_API}/api/v1/customermanagement`
}

export async function getCustomers(): Promise<ApiResponse<Models.CustomersResponse>> {
    return Axios.get<Models.CustomersResponse>(`${baseUrl()}/customers`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.CustomersResponse>(e))
}

export async function storeCustomer(customer: Models.Customer): Promise<ApiResponse<Models.CustomersResponse>> {
    let body: Models.CustomerParams = {name: customer.navn, address: customer.adresse, phone: customer.telefon, contact: customer.kontakt, comment: customer.kommentar,
        active: customer.active, permissionDoorOpener: customer.permissionDoorOpener, permissionGlobalSearch: customer.permissionGlobalSearch,
        permissionInfoModule: customer.permissionInfoModule, permissionDigitalLicenses: customer.permissionDigitalLicenses}
    let url: string = `${baseUrl()}/customers`
    if (customer.id > 0) {
        // Update an existing customer
        url += `/${customer.id}`
    }

    return Axios.post<Models.CustomersResponse>(url, {...body})
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.CustomersResponse>(e))
}

// Get users for a specific customer
export async function getCustomerUsers(customerId: number): Promise<ApiResponse<UserModels.UsersData>> {
    return Axios.get<UserModels.UsersData>(`${baseUrl()}/users/${customerId}`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<UserModels.UsersData>(e))
}

// Store user for a specific customer. If the userId is 0, this is considered a new user. Otherwise, a user with the ID userId will be updated
export async function storeCustomerUser(customerId: number, userId: number, params: UserModels.StoreParams): Promise<ApiResponse<UserModels.UsersData>> {
    if (userId === 0) {
        return Axios.post<UserModels.UsersData>(`${baseUrl()}/users/${customerId}`, { ...params.body })
            .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined}; })
            .catch((e) => handleApiErrors<UserModels.UsersData>(e))
    } else {
        return Axios.post<UserModels.UsersData>(`${baseUrl()}/users/${customerId}/${userId}`, { ...params.body })
            .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
            .catch((e) => handleApiErrors<UserModels.UsersData>(e))
    }
}

export async function getCustomerLocations(customerId: number): Promise<ApiResponse<ShortModels.Location[]>> {
    return Axios.get<ShortModels.Location[]>(`${baseUrl()}/customerlocations/${customerId}`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<ShortModels.Location[]>(e))
}


export async function getTerminalChanges(customerId: number): Promise<ApiResponse<Models.TerminalChangesResponse>> {
    return Axios.get<Models.TerminalChangesResponse>(`${baseUrl()}/terminalchange/${customerId}`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.TerminalChangesResponse>(e))
}

export async function storeTerminalChanges(customerId: number, body: Models.TerminalChange): Promise<ApiResponse<Models.TerminalChangesResponse>> {
    let url: string = `${baseUrl()}/terminalchange/${customerId}`
    return Axios.post<Models.TerminalChangesResponse>(url, {...body})
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.TerminalChangesResponse>(e))
}

export async function deleteTerminalChange(customerId: number, id: number): Promise<ApiResponse<Models.TerminalChangesResponse>> {
    return Axios.delete<Models.TerminalChangesResponse>(`${baseUrl()}/terminalchange/${customerId}/${id}`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.TerminalChangesResponse>(e))
}
